import React from 'react';

const JSRapidoziBtn = (props) => {
  // let handleClick = props.handleClick;
  let hasIcon = false;
  let hasTitle = false;
  let cl = 'frfr-js-rapidozi__btn';
  let jsxTitle = null;
  let jsxFontAwsome = null;
  if (typeof props.i === 'string' && props.i !== '') {
    hasIcon = true;
    jsxFontAwsome = (
      <i className={props.i} aria-hidden="true"></i>
    );
  }
  if (typeof props.title === 'string' && props.title !== '') {
    hasTitle = true;
    jsxTitle = (
      <span>{props.title}</span>
    );
  }
  if (hasIcon && hasTitle) {
    cl += ' frfr-js-rapidozi__btn--icon-and-title';
  }
  if (props.themeCompoColorJseditor === true) {
    cl += ' frfr-js-rapidozi__btn--themecompo-color-jseditor';
  }
  return (
    <div className={cl} onClick={props.handleClick}><abbr title={props.tooltip}>{jsxFontAwsome}{jsxTitle}</abbr></div>
  );
};

export default JSRapidoziBtn;